import { useState } from "react";
import Cropper from "react-easy-crop";
import Overlay from "@/components/Overlay";
import { cropSquare } from "@/lib/imageUtils";
import { RotateCcw, RotateCw, X } from "lucide-react";

export default function ImageCropper({ src, onCancel, onConfirm }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [area, setArea] = useState(null);

  const confirm = async () => onConfirm(await cropSquare(src, area, rotation));
  const rotate = (d) => setRotation((r) => (r + d + 360) % 360);

  return (
    <Overlay onClose={onCancel} z="z-[70]" className="max-w-md" testid="image-cropper-modal">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-2xl gold-text">Crop & rotate</h3>
        <button onClick={onCancel} className="text-slate-400" data-testid="cropper-close"><X size={20} /></button>
      </div>
      <p className="text-xs text-slate-400 mt-1">Drag to position, zoom with the slider. All catalogue photos are square for a uniform grid.</p>
      <div className="relative w-full aspect-square mt-4 rounded-2xl overflow-hidden bg-slate-900">
        <Cropper image={src} crop={crop} zoom={zoom} rotation={rotation} aspect={1} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={(_, px) => setArea(px)} />
      </div>
      <div className="flex items-center gap-3 mt-4">
        <button onClick={() => rotate(-90)} className="h-9 w-9 rounded-xl glass border border-amber-500/20 flex items-center justify-center text-slate-300" data-testid="cropper-rotate-left"><RotateCcw size={15} /></button>
        <input type="range" min={1} max={3} step={0.01} value={zoom} onChange={(e) => setZoom(Number(e.target.value))} className="flex-1 accent-[#C6A15B]" data-testid="cropper-zoom" />
        <button onClick={() => rotate(90)} className="h-9 w-9 rounded-xl glass border border-amber-500/20 flex items-center justify-center text-slate-300" data-testid="cropper-rotate-right"><RotateCw size={15} /></button>
      </div>
      <button disabled={!area} onClick={confirm} className="w-full btn-gold py-3 rounded-xl mt-4 disabled:opacity-60" data-testid="cropper-confirm">Use this crop</button>
    </Overlay>
  );
}
